<template>
    <v-container fluid ma-0 pa-0>
        <v-row justify="center" align="center" no-gutters>
            <v-col cols="12" md="6">
            <v-card flat color="transparent"
                    max-width = "700px"
                    class="ma-5 pa-5"
            >
                <v-card-title>
                    <h2 v-if="$vuetify.breakpoint.mdAndUp" style="color:#4A87FF; text-align: left">
                        {{header}}
                    </h2>
                    <h4 v-if="$vuetify.breakpoint.smAndDown" style="color:#4A87FF; text-align: left">
                        {{header}}
                    </h4>
                </v-card-title>
                <v-card-text>
                    <p  :style="{textAlign: 'left',
                               fontSize: $vuetify.breakpoint.mdAndUp? '26px' : '16px',
                            marginTop: '20px'}">
                        {{content}}
                    </p>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn text
                           color="#4A87FF"
                           large
                           :style="{fontSize: $vuetify.breakpoint.mdAndUp? '20px' : '16px'}"
                           :to="action.link">
                        {{action.word}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
            <v-col cols="12" md="6">
                <v-img :src="imgSrc" >
                </v-img>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Welcome",
        data(){
            return {
                header:"Get the Right Products to Market, Faster.",
                content:"UBehave is the product excellence system that helps you understand what users need,\n" +
                    "                            prioritize what to build, and rally everyone around your roadmap.",
                action: {
                    word:"TRY NOW",
                    link:""
                },
                imgSrc: require('../../assets/img/manAndwomen.png')
            }
        }
    }
</script>

<style scoped>
    .row {
        height: 100%;
    }
</style>